var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWritingTabIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M.766 27.792c0-15.188 12.312-27.5 27.5-27.5 15.187 0 27.5 12.312 27.5 27.5s-12.313 27.5-27.5 27.5c-15.188 0-27.5-12.312-27.5-27.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-52.19 32.5 22)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-52.191 36.5 16.5)"
  }), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-52.19 23.5 33.5)"
  }), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-52.19 27.5 28)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.936 17.927l.386-.498-1.598-1.24-.386.498-.996-.772.386-.498-.64-.497-7.39 9.524.996.772 6.618-8.528 2.793 2.168-6.617 8.528.996.773-2.52 3.246 7.624-9.824-.498-.386 1.103-1.423.498.387 1.182-1.524-.555-.431-.387.498z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.948 27.467l-.773.995 2.794 2.168 1.746-2.25-.973 1.255z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.948 27.467l.974-1.255 2.793 2.168.773-.996-2.794-2.168-1.746 2.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.174 38.098l.205.158-1.933 1.794 1.129.876 7.39-9.523-.996-.773z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.38 35.93l5.796-7.468-.996-.772 2.519-3.246-9.909 12.77 1.129.875 1.258-2.317z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.927 38.872l.51.396.936-.87-.836-.649z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.488 27.384l-.773.996-1.746 2.25.996.773 2.518-3.246z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.175 28.462l.773-.995 1.746-2.25-.995-.773-2.52 3.246z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.976 40.624l.951-1.752-1.009-.783-1.571 2.896 1.685 1.307 2.414-2.242-1.009-.782z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.558 36.99l.979.76.04-.073.857.665-.06.057.978.759.822-1.06-2.793-2.168z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.174 38.098l-.822 1.06-.979-.76-.936.87 1.01.782 1.932-1.794z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.537 37.75l-.979-.76.823-1.06-.204-.158-1.259 2.317 1.01.783z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.124 21.995l-4.77 6.146 1.423 1.103 5.872-7.568-1.958-1.52-1.103 1.423z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-52.19 37 20.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.99 20.99v-.63h1.8v.63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.163 13.567l-1.435 1.85.996.772.662-.854 1.599 1.24-.663.854.996.773 1.435-1.85z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-52.188 37.5 18)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.312 18.695v-1.26h.63v1.26z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-52.188 35 16)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.718 16.682v-1.26h.63v1.26z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritingTabIcon);
export default __webpack_public_path__ + "static/media/writing_tab_icon.5d8e315beac9211871dfa3c6dae5e4a5.svg";
export { ForwardRef as ReactComponent };